import { HookNavGet } from 'Hook'
import { TypeEntityLinkTo, TypeNavDataPageRequestSortDirection, TypeNavHttpControl, TypeUrlParam } from 'Type'

const HookNavGetAll = <T>(linkTo :string | TypeEntityLinkTo | undefined, sortDirection? :TypeNavDataPageRequestSortDirection) :TypeNavHttpControl<T> => {
    const paramUpdates :TypeUrlParam[] = [{ type: 'size', values: [`${-1}`] }]
    if (sortDirection) paramUpdates.push({type: 'sortDirection', values: [sortDirection]})
    return HookNavGet({linkTo, paramUpdates})
}

export default HookNavGetAll